// extracted by mini-css-extract-plugin
export const staticContent = "index-module--static-content--3yNhq";
export const scrollForMore = "index-module--scroll-for-more--2a8Co";
export const MoveUpDown = "index-module--MoveUpDown--3J637";
export const mainHolder = "index-module--main-holder--1euGx";
export const center = "index-module--center--13cDa";
export const title = "index-module--title--1XGBb";
export const fb = "index-module--fb--nLSzK";
export const photoGallery = "index-module--photo-gallery--2a8hi";
export const photo = "index-module--photo--1ur4c";